<template>
  <div style="background: #ffffff;border-radius: 8px;padding: 12px 24px 24px 24px">
    <div class="fontSize20gay text-left">实验室设备维修登记</div>
    <div style="border-bottom: 1px solid #EBEBEB;border-top: 1px solid #EBEBEB;margin-top: 16px;padding: 36px 0">
      <div style="width: 800px;margin: auto">
        <el-form :model="pageForm" :rules="pageFormRules" ref="formRef">
          <el-form-item label="日期" prop="date" size="large" label-width="160px">
            <el-date-picker v-model="pageForm.date"
                            type="date"
                            size="large"
                            placeholder="请选择日期"
                            value-format="YYYY-MM-DD"/>
          </el-form-item>
          <el-form-item label="实验室" prop="laboratoryId" size="large" label-width="160px">
            <el-select v-model="pageForm.laboratoryId"
                       filterable
                       class="room-select-tl"
                       placeholder="选择实验室"
                       size="large">
              <el-option v-for="item in laboratoryList"
                         :key="item.id"
                         :label="item.name"
                         :value="item.id"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="维修仪器名称" prop="equipmentName" size="large" label-width="160px">
            <el-input type="text" v-model="pageForm.equipmentName"></el-input>
          </el-form-item>
          <el-form-item label="维修前设备仪器状态" prop="equipmentBeforeState" size="large" label-width="160px">
            <el-input type="text" v-model="pageForm.equipmentBeforeState"></el-input>
          </el-form-item>
          <el-form-item label="维修内容" prop="content" size="large" label-width="160px">
            <el-input type="text" v-model="pageForm.content"></el-input>
          </el-form-item>
          <el-form-item label="维修后设备仪器状态" prop="equipmentAfterState" size="large" label-width="160px">
            <el-input type="text" v-model="pageForm.equipmentAfterState"></el-input>
          </el-form-item>
          <el-form-item label="管理员" prop="userId" size="large" label-width="160px">
            <el-select v-model="pageForm.userId"
                       filterable
                       class="room-select-tl"
                       placeholder="搜索管理员"
                       size="large"
                       remote
                       :remote-method="getUserList"
                       @change="selectChange">
              <el-option v-for="item in teacherList"
                         :key="item.id"
                         :label="item.name"
                         :value="item.id"
              />
              <template #prefix>
                <div>
                  {{ teacher.code }}
                </div>
              </template>
            </el-select>
          </el-form-item>
          <el-form-item label="现场照片" prop="image" size="large" label-width="160px">
            <image-list ref="imageList"></image-list>
          </el-form-item>
          <el-form-item label="备注" prop="notes" size="large" label-width="160px">
            <el-input v-model="pageForm.notes"
                      :autosize="{ minRows: 2, maxRows: 4 }"
                      type="textarea"
            />
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div class="marginTop15px">
      <button class="subBtn" @click="subData">保存</button>
      <button class="qxBtn" @click="qxBtn">取消</button>
    </div>
  </div>
</template>

<script>
import {addMaintenance, getAllLaboratory, getTeacherList} from "@/api/examination";
import ImageList from "@/view/patrolInspection/ImageList";

export default {
  name: "laboratoryEquipment",
  components: {ImageList},
  data(){
    return {
      teacherList: [],
      teacher: {},
      laboratoryList: [],
      pageForm: {
        // 日期
        date: '',
        // 实验室名称
        laboratoryId: '',
        // 维修设备仪器名称
        equipmentName: '',
        // 维修前设备仪器状态
        equipmentBeforeState: '',
        // 维修内容
        content: '',
        // 维修后设备仪器状态
        equipmentAfterState: '',
        // 管理员
        userId: '',
        // 备注
        notes: '',
      },
      pageFormRules: {
        date: [
          { required: true, message: '请选择日期', trigger: 'blur' },
        ],
        laboratoryId: [
          { required: true, message: '请选择实验室', trigger: 'blur' },
        ],
        equipmentName: [
          { required: true, message: '请填写维修仪器名称', trigger: 'blur' },
        ],
        equipmentBeforeState: [
          { required: true, message: '请填写维修前设备仪器状态', trigger: 'blur' },
        ],
        content: [
          { required: true, message: '请填写维修内容', trigger: 'blur' },
        ],
        equipmentAfterState: [
          { required: true, message: '维修后设备仪器状态', trigger: 'blur' },
        ],
        userId: [
          { required: true, message: '请选择管理员', trigger: 'blur' },
        ],
      },
      id: null,
    }
  },
  mounted() {
    this.init();
    let data=this.$root.useRoute.query;
    if(data.info){
      this.pageForm=JSON.parse(data.info);
      this.$refs.imageList.setImageInfo(this.pageForm.img);
      if(this.pageForm && this.pageForm.teacher) {
        this.getUserList(this.pageForm.teacher.name);
      }
    }
  },
  methods: {
    selectChange(e){
      this.teacher = this.teacherList.find(iter => iter.id == e) || {}
    },
    init(){
      getAllLaboratory().then(res => {
        if (res.success) {
          this.laboratoryList = res.data
        } else {
          this.$root.ElMessage.error(res.message)
        }
      })
    },
    getUserList(keyword){
      if (keyword) {
        getTeacherList({ name: keyword }).then(res => {
          if (res.success) {
            this.teacherList = res.data
          } else {
            this.$root.ElMessage.error(res.message)
          }
        })
      }
    },
    getTeachers(){

    },
    subData(){
      this.$refs.formRef.validate((valid, error) => {
        if (valid) {
          const handler = addMaintenance
          let method='post';
          if(this.pageForm.id){method='put'}
          handler({ ...this.pageForm, img: this.$refs.imageList.getImg() },method).then(res => {
            if(res.success){
              this.$root.ElMessage({type:'success',message:res.message});
              setTimeout(() => {
                this.$root.useRouter.replace('/patrolInspection/laboratoryEquipmentList')
              }, 500)
            }else{
              this.$root.ElMessage.error(res.message);
            }
          })
        } else {
          const key = Object.keys(error)[0]
          const msg = error[key][0].message
          this.$root.ElMessage.error(msg)
        }
      })
    },
    qxBtn(){
      this.$root.useRouter.go(-1);
    },
  }
}
</script>

<style lang="scss" scoped>

</style>